import { csrfToken } from 'next-auth/client';
import Layout from '../components/layout';
import SignInForm from '../components/signin-form';

export default function SignIn({ csrfToken }) {

  return (
    <Layout>
      <SignInForm csrfToken={csrfToken}  />
    </Layout>
  );
}

SignIn.getInitialProps = async (context) => {
  return {
    csrfToken: await csrfToken(context),
  };
};
